<template>
  <div>
    <b-form-group label-for="recipient" label-cols-md="3">
      <b-form-checkbox v-model="sameAddress" :disabled="!!address.$.recipient">Schuladresse verwenden</b-form-checkbox>
    </b-form-group>

    <b-form v-if="!sameAddress" autocomplete="off">
      <b-form-group label-for="recipient" label="Empfänger*" label-cols-md="3">
        <b-form-input type="text" id="recipient" v-model="address.recipient" autocomplete="off" required/>
      </b-form-group>

      <b-form-group label-for="line1" label="Zeile 1*" label-cols-md="3">
        <b-form-input id="line1" v-model="address.line1" autocomplete="off" required/>
      </b-form-group>

      <b-form-group label-for="line2" label="Zeile 2" label-cols-md="3">
        <b-form-input id="line2" v-model="address.line2" autocomplete="off" required/>
      </b-form-group>

      <b-form-group label-for="line3" label="Zeile 3" label-cols-md="3">
        <b-form-input id="line3" v-model="address.line3" autocomplete="off" required/>
      </b-form-group>

      <b-form-group label-for="zip" label="Postleitzahl*" label-cols-md="3">
        <b-form-input type="text" id="zip" v-model="address.zip" autocomplete="off" required/>
      </b-form-group>

      <b-form-group label-for="city" label="Ort*" label-cols-md="3">
        <b-form-input type="text" id="city" v-model="address.city" autocomplete="off" required/>
      </b-form-group>

      <div class="mt-5 text-right">
        <b-button type="button" v-on:click="this.delete" variant="danger" :disabled="!address.$.recipient">
          Löschen
        </b-button>

        <b-button type="button" v-on:click="this.save" variant="primary" :disabled="saveDisabled">
          Speichern
        </b-button>
      </div>
    </b-form>
  </div>
</template>

<script>
import {InvoiceAddress} from '@/models'

export default {
  name: 'InvoiceAddress',
  props: ['schoolID'],

  data () {
    return {
      sameAddress: true,
      address: new InvoiceAddress({school_id: this.schoolID})
    }
  },

  mounted () {
    this.address.school_id = this.schoolID
    this.address.fetch()
      .then(() => { this.sameAddress = false })
      .catch(() => { /* ignore */ })
  },

  computed: {
    saveDisabled () {
      if (!this.address.changed()) return true
      if (!this.address.recipient) return true
      if (!this.address.line1) return true
      if (!this.address.zip || !this.address.city) return true

      return false
    }
  },

  methods: {
    save () {
      this.address.save()
        .then(() => {
          this.$eventHub.$emit('info', 'Rechnungsadresse erfolgreich gespeichert')
        })
    },

    delete () {
      const onDelete = () => {
        this.address.delete()
          .then(() => {
            this.sameAddress = true
            this.address = new InvoiceAddress({school_id: this.schoolID})
            this.$eventHub.$emit('info', 'Rechnungsadresse gelöscht')
          })
          .catch(e => this.$eventHub.$emit('error', e))
      }

      this.$eventHub.$emit('confirm', 'Rechnungsadresse wirklich löschen?', 'Löschen bestätigen', onDelete)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/schools/InvoiceAddress.vue